import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import { initialStoricoFilterData } from "./helper";

const initialState = {
  storicoConfigurazioni: {
    data: [],
    totalNumRecords: 0,
    loading: false,
  },
  filterData: initialStoricoFilterData,
  portalUserData: {
    data: [],
    loading: false,
  },
  exportStoricoLoading: false,
};

const setStoricoConfigurazioniData = (state, action) => {
  return updateObject(state, {
    storicoConfigurazioni: updateObject(state.storicoConfigurazioni, {
      [action.key]: action.value,
    }),
  });
};

const setExportStoricoLoading = (state, action) => {
  return updateObject(state, {
    exportStoricoLoading: action.value,
  });
};

const setStoricoFilterData = (state, action) => {
  return updateObject(state, {
    filterData: updateObject(state.filterData, {
      [action.key]: action.value,
    }),
  });
};

const storicoConfigurazioniReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_STORICO_CONFIGURAZIONI_DATA_AND_LOADING:
      return setStoricoConfigurazioniData(state, action);
    case actionTypes.EXPORT_STORICO_LOADING:
      return setExportStoricoLoading(state, action);
    case actionTypes.GET_STORICO_FILTER_DATA:
      return setStoricoFilterData(state, action);
    default:
      return state;
  }
};

export default storicoConfigurazioniReducer;
